import React, {useMemo} from 'react';
import NovelStoryBookViewDraft from './NovelStoryBookViewDraft';
import {plainTextFromManuscriptEntry} from '../utils/childrensBookManuscriptContent';
import {resolveChildrensBookNovelDestinationV1E3} from '../utils/childrensBookNovelRouteBridgeV1E3';
import {buildChildrensBookNovelPresentationAdapterV1E4C} from '../utils/childrensBookNovelPresentationAdapterV1E4C';

// Thin reuse boundary. NOT YET a live route. The actual Novel Book View owns
// ALL of its visuals and chapter navigation; no new Book Workspace/cards exist.
// The parent must retain Children's Book Blueprint and the original editor.
export default function ChildrensBookNovelBookViewReuseV1E4C({
  draft, navigation, lang='en', onBack, onOpenExistingScene,
  onUnsupportedStructureChange, returnTarget=null,
  onChildrensBookAddChapter, onChildrensBookAddScene,
  onChildrensBookRenameChapter, onChildrensBookMoveChapter,
  onChildrensBookBookSetup, onChildrensBookRenderMatter, childrensBookMatterCounts, childrensBookAudienceReady=false,
}) {
  const adapted=useMemo(()=>buildChildrensBookNovelPresentationAdapterV1E4C({
    draft,navigation,readManuscriptText:plainTextFromManuscriptEntry,
  }),[draft,navigation]);
  const project=useMemo(()=> adapted.ok && returnTarget
    ? {...adapted.project,childrensBookReturnTargetV1E4D:returnTarget}
    : adapted.project,[adapted,returnTarget]);
  if (!adapted.ok) {
    // Parent opens ORIGINAL physical-page-only route for legacy books.
    return null;
  }
  return <NovelStoryBookViewDraft
    project={project} lang={lang} onBack={onBack}
    onChildrensBookBookSetup={onChildrensBookBookSetup}
    onChildrensBookRenderMatter={onChildrensBookRenderMatter}
    childrensBookMatterCounts={childrensBookMatterCounts}
    childrensBookAudienceReady={childrensBookAudienceReady}
    onChildrensBookAddChapter={onChildrensBookAddChapter}
    onChildrensBookAddScene={onChildrensBookAddScene}
    onChildrensBookRenameChapter={onChildrensBookRenameChapter}
    onChildrensBookMoveChapter={onChildrensBookMoveChapter}
    onOpenWriterStudio={({chapterId='',sceneId='',newScene=false})=>{
      // No fabricated scene or Chapter, and no Novel persistence calls.
      if(newScene && chapterId) {
        onChildrensBookAddScene?.(chapterId);
      } else if (!chapterId || !sceneId) {
        onUnsupportedStructureChange?.();
      } else {
        const target = resolveChildrensBookNovelDestinationV1E3({navigation,chapterId,sceneId});
        if (!target.ok) onUnsupportedStructureChange?.();
        else onOpenExistingScene?.({chapterId,sceneId});
      }
    }} />;
}
